/*
* Report page: special assessment schedule (shown when there are more rows than fit inline)
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Table } from 'react-bootstrap';

import * as ReportComponents from '../report-components';
import { getSpecialAssessmentPresentation, SPECIAL_ASSESSMENT_SCHEDULE_ROWS_PER_PAGE } from '../special-assessments-presentation';

export const getScheduleChunks = (rows: any[], chunkSize: number) => _.chunk(rows, Math.max(1, chunkSize));

export const Render = ({ registerFunc, refFunc, scrollToFunc, maxTableRowsPerPage = 0, pageTitle = '', className = '', pageConfiguration, pageCount, reportData, ...rest }) => {
    const sectionName = ReportComponents.ReportSectionNames.specialAssessments;
    const ReportPageWithRegister = ReportComponents.withPageRegistration(ReportComponents.ReportPageHeaderFooter, sectionName, registerFunc, refFunc, scrollToFunc);
    const getRowKey = (id, tableName = 'data') => ReportComponents.getRowKey(id, sectionName, tableName);

    const chunkSize = (maxTableRowsPerPage > 0) ? maxTableRowsPerPage : _.get(pageConfiguration, 'maxTableRowsPerPage', SPECIAL_ASSESSMENT_SCHEDULE_ROWS_PER_PAGE);
    const presentation = getSpecialAssessmentPresentation(_.get(reportData, 'specialAssessmentRows', []));

    const pages = getScheduleChunks(presentation.rows, chunkSize).map((rowChunk, ind) => (
        <div key={getRowKey(`sa-page-${ind}`)}>
            <ReportPageWithRegister pageIndex={ind} title={pageTitle} className={className} totalPageCount={pageCount} showFooter={true} footerData={reportData}>
                <div className="pdf-page-special-assessments-table-container">
                    <Table condensed={true} bordered={true} responsive={false} className="pdf-data-table pdf-page-special-assessments-table">
                        <thead>
                            <tr>
                                <th className="col-sa-year">Year</th>
                                <th className="col-sa-name">Name</th>
                                <th className="col-sa-class">Type</th>
                                <th className="col-sa-amount">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rowChunk.map((row, i) => (
                                <tr key={getRowKey(`sa-${ind}-tr-${i}-${row.id}`)}>
                                    <td className="text-center">{row.year}</td>
                                    <td className="text-left">{row.name}</td>
                                    <td className="text-center">{row.clientRequested ? 'Client-Requested' : 'Recommended'}</td>
                                    <td className="text-right"><ReportComponents.Currency value={row.amount} decimals={0} /></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </ReportPageWithRegister>
        </div>
    ));

    return (
        <div>
            {pages}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/report-page-special-assessments.tsx